import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { devtools } from 'zustand/middleware'

// Import slices
import { authenticationSlice } from './authentication/authentication.slice'
import { dashboardSlice } from './dashboard/dashboard.slice'
import { documentsSlice } from './documents/documents.slice'
import { downloadsSlice } from './downloads/downloads.slice'
import { navigationSlice } from './navigation/navigation.slice'
import { plantInfosSlice } from './plantInfos/plantInfos.slice'
import { plantSelectSlice } from './plantSelect/plantSelect.slice'

//  Global types
export type RootState = ReturnType<typeof authenticationSlice> &
  ReturnType<typeof dashboardSlice> &
  ReturnType<typeof documentsSlice> &
  ReturnType<typeof downloadsSlice> &
  ReturnType<typeof navigationSlice> &
  ReturnType<typeof plantInfosSlice> &
  ReturnType<typeof plantSelectSlice>

// Global store creation
export const useStore = create<RootState>()(
  devtools(
    immer((set, get, store) => ({
      // Combine all slices
      ...authenticationSlice(set as any, get as any, store as any),
      ...dashboardSlice(set as any, get as any, store as any),
      ...documentsSlice(set as any, get as any, store as any),
      ...downloadsSlice(set as any, get as any, store as any),
      ...navigationSlice(set as any, get as any, store as any),
      ...plantInfosSlice(set as any, get as any, store as any),
      ...plantSelectSlice(set as any, get as any, store as any),
    }))
  )
)
